<template>
  <div>
    <div >
      <table class="table">
        <thead>
          <tr>
            <th>
              {{ $t('reports.reports') }}
            </th>
            <th>
              {{ $t('evaluation.snapshots') }}
            </th>
            <th>
              {{ $t('reports.type') }}
            </th>
            <th>
              {{ $t('reports.section') }}
            </th>
            <th>
              {{ $t('reports.actions.actions') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <multiselect v-model="reportTypeSelected" :options="reportTypes" :searchable="false" :close-on-select="true" label="name" placeholder="Type..." @input="computeGraphType">
                <template slot="singleLabel" slot-scope="{ option }">{{ $t('reports.types.' + option.name ) }}</template>
                <template slot="option" slot-scope="props"><span class="option__title">{{ $t('reports.types.' + props.option.name ) }}</span></template>
              </multiselect>
            </td>
            <td>
              <multiselect v-model="selectedSnapshots" :options="snapshots" :searchable="true" :multiple="true" :close-on-select="false" :clear-on-select="false" placeholder="Snapshots..." label="title" track-by="title" @input="computeGraphType"/>
            </td>
            <td>
              <multiselect :disabled="reportTypeSelected && reportTypeSelected.name === 'summary'" v-model="graphTypeSelected" :options="graphTypes" :searchable="false" :close-on-select="true" label="name" placeholder="Graphs..." @input="computeCombo">
                <template slot="singleLabel" slot-scope="{ option }">{{ $t('reports.types.' + option.name ) }}</template>
                <template slot="option" slot-scope="props"><span class="option__title">{{ $t('reports.types.' + props.option.name ) }}</span></template>
              </multiselect>
            </td>
            <td>
              <multiselect :disabled="isSectionSelectable" v-model="entrySelected" :options="entries" :searchable="false" :close-on-select="true" label="label" placeholder="Sections..." @input="computeCombo"/>
            </td>
            <td>
              <a v-for="action in actions" :key="action.id" :title="$t('reports.actions.' + action.text)" :class="action.disabled ? 'disabled' : ''" href="#" @click="routeActionFilters(action.id)">
                <fa :icon="action.icon" size="lg" fixed-width/>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ReportDropdownList',
  components: {
    Multiselect
  },
  props: {
    recipient: { required: true, type: Object },
    entries: { required: true, type: Array },
    evaluations: {},
    currentTab: 0,
    snapshots: '',
    snapshotKid: '',
    snapshotAdult: '',
    snapshotYoung: '',
    createToolTip: ''
  },

  data: () => ({
    tChart: 'evaluation.charts.',
    ourLabels: ['total',
      'regular_activity',
      'communication', 'moving', 'nutrition',
      'physical_psy_condition', 'healing', 'dwelling',
      'social_roles',
      'responsibility', 'personal_relation', 'associative_life',
      'education', 'work', 'hobby'],
    ourKidLabels: ['total',
      'regular_activity',
      'communication', 'moving', 'nutrition',
      'physical_psy_condition', 'healing', 'dwelling',
      'social_roles',
      'responsibility', 'personal_relation', 'associative_life',
      'education', 'hobby'],
    ourLabelsRadar: ['communication', 'moving', 'nutrition',
      'physical_psy_condition', 'healing', 'dwelling',
      'responsibility', 'personal_relation', 'associative_life',
      'education', 'work', 'hobby'],
    ourKidLabelsRadar: [
      'communication', 'moving', 'nutrition',
      'physical_psy_condition', 'healing', 'dwelling',
      'responsibility', 'personal_relation', 'associative_life',
      'education', 'hobby'],
    currentMask: undefined,
    reportTypes: [
      { name: 'scores', $isDisabled: false },
      { name: 'satisfaction', $isDisabled: false },
      { name: 'summary', $isDisabled: false }
    ],
    graphTypes: [
      { name: 'avg_histogram', $isDisabled: true },
      { name: 'table', $isDisabled: true },
      { name: 'pies', $isDisabled: true },
      { name: 'stacked_bars', $isDisabled: true },
      { name: 'radar', $isDisabled: true }
    ],
    reportTypeSelected: null,
    graphTypeSelected: null,
    entrySelected: null,
    selectedSnapshots: [],
    actions: [
      { id: 1, text: 'generate_pdf', icon: 'file-pdf', disabled: true },
      { id: 2, text: 'generate_word', icon: 'file-word', disabled: true },
      { id: 3, text: 'generate_csv', icon: 'file-excel', disabled: true }
    ]
  }),

  computed: {
    isSectionSelectable () {
      if (this.selectedSnapshots.length < 1) {
        return true
      }
      if (this.graphTypeSelected === null || this.reportTypeSelected === null) {
        return true
      }
      return !((this.reportTypeSelected.name === 'scores' && this.graphTypeSelected.name === 'avg_histogram') || (this.reportTypeSelected.name === 'satisfaction' && this.graphTypeSelected.name === 'stacked_bars'))
    }
  },

  created () {
    this.cleanSnapshots()
  },

  methods: {

    cleanSnapshots () {
      const age = new Date().getFullYear() - this.recipient.birth_year
      if (age >= 0 && age <= 4) {
        this.snapshots = this.snapshotKid
      } else if (age > 4 && age <= 13) {
        this.snapshots = this.snapshotYoung
      } else {
        this.snapshots = this.snapshotAdult
      }
    },

    computeGraphType () {
      this.graphTypeSelected = null
      this.computeCombo()
    },

    computeCombo () {
      this.csvAction()
      switch (this.reportTypeSelected.name) {
        case 'scores' :
          this.graphTypes = [
            { name: 'avg_histogram' },
            { name: 'table' },
            { name: 'radar' }
          ]
          break
        case 'satisfaction':
          if (this.selectedSnapshots.length > 1) {
            this.graphTypes = [
              { name: 'stacked_bars' },
              { name: 'table' }
            ]
          } else {
            this.graphTypes = [
              { name: 'pies' },
              { name: 'table' }
            ]
          }
          break
        case 'summary':
          this.graphTypes = []
          this.graphTypeSelected = null
          break
      }
      if (!this.graphTypeSelected) { this.graphTypeSelected = this.graphTypes[0] }
      if (this.graphTypeSelected && this.graphTypeSelected.$isDisabled) {
        this.graphTypeSelected = null
      }
      if (this.entrySelected === null) {
        this.entrySelected = this.entries[0]
      }
      this.checkCombo()
    },

    checkCombo () {
      const oneSnapshot = this.selectedSnapshots.length === 1
      const multipleSnapshots = this.selectedSnapshots.length > 1

      if (oneSnapshot && this.reportTypeSelected.name === 'scores' && this.graphTypeSelected.name === 'avg_histogram') {
        this.enableActions()
      } else if (oneSnapshot && this.reportTypeSelected.name === 'satisfaction' && this.graphTypeSelected.name === 'pies') {
        this.enableActions()
      } else if (oneSnapshot && this.reportTypeSelected.name === 'summary' && (this.graphTypeSelected === null || this.graphTypeSelected === undefined)) {
        this.enableActions()
      } else if (multipleSnapshots && this.reportTypeSelected.name === 'scores' && this.graphTypeSelected.name === 'avg_histogram') {
        this.enableActions()
      } else if (this.reportTypeSelected.name === 'scores' && this.graphTypeSelected.name === 'table') {
        this.enableActions()
      } else if (multipleSnapshots && this.reportTypeSelected.name === 'satisfaction' && this.graphTypeSelected.name === 'stacked_bars') {
        this.enableActions()
      } else if (this.reportTypeSelected.name === 'satisfaction' && this.graphTypeSelected.name === 'table') {
        this.enableActions()
      } else if (this.reportTypeSelected.name === 'scores' && this.graphTypeSelected.name === 'radar') {
        this.enableActions()
      } else if (multipleSnapshots && this.reportTypeSelected.name === 'summary' && (this.graphTypeSelected === null || this.graphTypeSelected === undefined)) {
        this.enableActions()
      } else {
        this.disableActions()
      }
      this.refreshGraphs()
    },

    refreshGraphs () {
      this.$emit('on-visualize', this.selectedSnapshots, this.reportTypeSelected.name, this.graphTypeSelected ? this.graphTypeSelected.name : null, this.entrySelected)
    },

    enableActions () {
      for (let i = 0; i < this.actions.length; i++) {
        this.actions[i].disabled = false
      }
      this.csvAction()
      return true
    },

    disableActions () {
      for (let i = 0; i < this.actions.length; i++) {
        this.actions[i].disabled = true
      }
      this.csvAction()
      return false
    },

    csvAction () {
      this.selectedSnapshots.length > 0 ? this.actions[2].disabled = false : this.actions[2].disabled = true
    },

    async routeActionFilters (actionId) {
      // await this.requestSnapshot(this.currentSnapshot)
      switch (actionId) {
        case 1:
          this.$emit('on-pdf-export', this.selectedSnapshots)
          break
        case 2:
          this.$emit('on-word-export', this.selectedSnapshots)
          break
        case 3:
          this.$emit('on-csv-export', this.selectedSnapshots)
          break
      }
    }
  }
}

</script>

<style scoped>
  label {
    padding:4px 24px 0px 24px;
    font-weight:bold;
  }

  .btn-report {
    color: #343a40;
    border-color: #343a40 !important;
  }

  .btn-report:hover {
    color: #343a40;
    border-color: #343a40 !important;
    background-color: #fff !important;
  }

  .disabled {
    cursor: not-allowed;
    color: gray
  }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// ../../../../resources/js/components/ReportDropdownList.vue